import LoginByJWT from './LoginByJWT'

export default LoginByJWT
